import { render, staticRenderFns } from "./ChecklistContainer.vue?vue&type=template&id=0b35e0a0&scoped=true"
import script from "./ChecklistContainer.vue?vue&type=script&lang=ts"
export * from "./ChecklistContainer.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistContainer.vue?vue&type=style&index=0&id=0b35e0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35e0a0",
  null
  
)

export default component.exports